// 兼职数据回传 - 后台模块容器（TDesign Layout + Menu，左菜单 + 右内容）
import React, { useState } from 'react';
import { Layout, Menu } from 'tdesign-react';
import 'tdesign-react/es/style/index.css';
import './parttime.css';
import TopNavbar from '../TopNavbar';
import ParttimeAudit from './ParttimeAudit';
import ParttimeImportAllocate from './ParttimeImportAllocate';
import ParttimeGroupData from './ParttimeGroupData';
import ParttimeSettlement from './ParttimeSettlement';
import ParttimeConfig from './ParttimeConfig';

// tdesign-react 的侧栏/内容需从 Layout 的静态子组件取，菜单项从 Menu 取
const { Aside, Content } = Layout;
const { MenuItem } = Menu;

const MENUS = [
  { key: 'H1', label: '兼职申请' },
  { key: 'H2', label: '数据分配' },
  { key: 'H3', label: '数据核对' },
  { key: 'H5', label: '对账结算' },
  { key: 'H6', label: '全局配置' },
];

const PAGES = {
  H1: <ParttimeAudit />,
  H2: <ParttimeImportAllocate />,
  H3: <ParttimeGroupData />,
  H5: <ParttimeSettlement />,
  H6: <ParttimeConfig />,
};

export default function ParttimeModule() {
  const [active, setActive] = useState('H1');
  const current = MENUS.find(m => m.key === active) || MENUS[0];

  return (
    <div>
      <TopNavbar />
      <Layout className="parttime-layout" style={{ height: 'calc(100vh - 60px)' }}>
        <Aside width="176px">
          <Menu value={active} onChange={(v) => setActive(v)} style={{ border: 'none', background: 'transparent' }}>
            {MENUS.map(m => (
              <MenuItem key={m.key} value={m.key}>{m.label}</MenuItem>
            ))}
          </Menu>
        </Aside>
        <Content className="pt-content" style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 20, boxSizing: 'border-box' }}>
          {PAGES[active]}
        </Content>
      </Layout>
    </div>
  );
}